var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.11815 6.10834C1.70231 4.48268 3.67959 0.542969 8.99982 0.542969C14.3201 0.542969 16.2973 4.48268 16.8815 6.10834C17.0898 6.68807 17.0898 7.31453 16.8815 7.89426C16.2973 9.51992 14.3201 13.4596 8.99982 13.4596C3.67959 13.4596 1.70231 9.51992 1.11815 7.89426C0.909835 7.31453 0.909835 6.68807 1.11815 6.10834ZM8.99984 9.5013C10.3805 9.5013 11.4998 8.38201 11.4998 7.0013C11.4998 5.62059 10.3805 4.5013 8.99984 4.5013C7.61913 4.5013 6.49984 5.62059 6.49984 7.0013C6.49984 8.38201 7.61913 9.5013 8.99984 9.5013Z",
    fill: "#033272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.facf8a9703e4c488b7b6876ec521ddf1.svg";
export { ForwardRef as ReactComponent };